import { http } from "@/app/lib/http/client";

export const catalogSearchService = {
  search: async (
    catalog: string,
    query: string = '',
    page: number = 1,
    paramQueries: string[] = [],
    extraParams?: Record<string, any>
  ) => {
    const endpoints: Record<string, string> = {
      'products': '/products',
      'users': '/authorization/users',
      'sucursales': '/sucursales',
      'roles': '/authorization/roles',
      'departments': '/departments',
      'units': '/units',
      'categories': '/categories',
      'sat_product_keys': '/sat-product-keys',
      'product_types': '/product-types',
      'doctors': '/pos/doctors',
      'report-products': '/reports/sales/filter-options/products',
      'report-customers': '/reports/sales/filter-options/customers',
      'report-inventory-products': '/reports/inventory/filter-options/products',
      'report-purchase-products': '/reports/purchases/filter-options/products',
      'report-purchase-suppliers': '/reports/purchases/filter-options/suppliers',
    };

    const endpoint = endpoints[catalog] || `/${catalog}`;
    const params = new URLSearchParams();

    if (query) {
      params.append('search', query);
    }

    if (page > 1) {
      params.append('page', page.toString());
    }

    if (paramQueries && paramQueries.length > 0) {
      params.append('fields', paramQueries.join(','));
    }

    if (extraParams) {
      Object.entries(extraParams).forEach(([key, val]) => {
        if (val !== undefined && val !== null) {
          params.append(key, String(val));
        }
      });
    }

    const response = await http.get(`${endpoint}?${params.toString()}`);
    const data = response.data.data;

    if (catalog === 'report-products' || catalog === 'report-customers' || catalog === 'report-inventory-products' || catalog === 'report-purchase-products' || catalog === 'report-purchase-suppliers') {
      return data;
    }

    if (data && !Array.isArray(data)) {
      if (Array.isArray(data.data)) {
        return data.data;
      }
      if (data.cash_registers && Array.isArray(data.cash_registers)) {
        return data.cash_registers;
      }
      if (data.items && Array.isArray(data.items) && data.pagination) {
        return {
          data: data.items,
          current_page: data.pagination.current_page,
          last_page: data.pagination.last_page,
          total: data.pagination.total
        };
      }
    }

    return data;
  }
}


/*
import {useState }from'react'
import {SearchInput }from'../components/ui/SearchInput'

exportfunctionDelFormulario() {
const [tipoProductoId,setTipoProductoId]=useState('')

return (
<div>
<label>Tipo de Producto</label>
<SearchInput
type="select"
catalog="product_types"
placeholder="Selecciona un tipo..."
onValueChange={(valorSeleccionado)=> {
setTipoProductoId(valorSeleccionado)
        }}
/>
</div>
  )
} */



/*
import {useState }from'react'
import {SearchInput }from'../components/ui/SearchInput'

exportfunctionMiPantalla() {
//  guardar lo que se busca
const [searchQuery,setSearchQuery]=useState('')

return (
<div>
<SearchInput
type="text"
placeholder="Buscar por nombre..."
onSearch={(textoEscrito)=> {
// guardamos el texto y regresamos la tabla a la página 1.
setSearchQuery(textoEscrito)
setCurrentPage(1)
        }}
/>
</div>
  )
}
} */
